<style lang="less" scoped>
.shop {
  background-color: #fff;
  padding: 0 24px;
  position: relative;
  .hander {
    padding-top: 10px;
    width: 100%;
    display: flex;
    align-items: center;
    .left {
      display: flex;
      align-items: center;
      padding: 0 16px;
      height: 54px;
      border-radius: 27px;
      border: 1px solid #eee;
      flex: 1;
      img {
        width: 32px;
        height: 32px;
      }
      input {
        font-size: 24px;
        flex: 1;
        margin-left: 12px;
        color: #999;
        border: none;
      }
    }
    .right {
      width: 45px;
      height: 65px;
      display: flex;
      align-items: center;
      flex-direction: column;
      img {
        width: 43px;
      }
      span {
        font-size: 22px;
        color: #333;
      }
    }
  }
  .screen {
    display: flex;
    align-items: center;
    height: 82px;
    position: relative;
    .t1 {
      text-align: center;
      font-size: 24px;
      color: #333;
      line-height: 82px;
      flex: 1;
    }

    .line {
      width: 25%;
      height: 3px;
      background: #e42129;
      position: absolute;
      bottom: 0;
      left: 0;
    }
    .price {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      .t2 {
        font-size: 24px;
        color: #333;
        line-height: 82px;
        margin-right: 8px;
      }
      .t3 {
        color: #e42129;
      }
      .image {
        display: flex;
        align-items: center;
        flex-direction: column;
        img {
          width: 16px;
        }
        .top {
          margin-bottom: 8px;
        }
        .bot {
          transform: rotateZ(180deg);
        }
      }
    }
    .t3 {
      color: #e42129;
    }
  }
  .cateBox {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    background-color: pink;
    box-sizing: border-box;
    padding-bottom: 50px;
    z-index: 10;
    .cate {
      position: absolute;
      right: 0;
      top: 0;
      width: 600px;
      height: 100%;
      background-color: #fff;

      .btnbox {
        position: absolute;
        bottom: 0;
        left: 0;
        height: 100px;
        width: 100%;
        display: flex;
        align-items: center;
        .cancel,
        .confirm {
          float: 1;
          height: 100px;
          font-size: 28px;
          color: #fff;
        }
      }
    }
  }
  .goodsBox {
    margin-top: 20px;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    justify-content: space-between;
  }
}

.vant-popup {
  height: 100vh;
  overflow: scroll;
}

.cate_box {
  width: 450px;
  height: calc(100% - 100px);
  // overflow: scroll;
  overflow-y: scroll;
  overflow-x: hidden;
  box-sizing: border-box;
  .all {
    width: 100%;
    height: 110px;
    font-size: 32px;
    color: #333;
    line-height: 110px;
    margin-left: 30px;
  }
  .cate_box_ul {
    width: 100%;
    .cate_item {
      width: 100%;
      height: 110px;
      font-size: 32px;
      overflow: hidden;
      color: #333;
      
      .title_box {
        display: flex;
        height: 110px;
        align-items: center;
        justify-content: space-between;
        box-sizing: border-box;
        padding: 0 30px;
        img {
          width: 30px;
        }
      }
      .child_box {
        height: 80px;
        line-height: 80px;
        margin-left: 60px;
      }
      .child_title {
        color: #e42129;
      }
    }
    .cate_open {
      height: auto;
      .title_box {
        color: #e42129;
      }
    }
  }
}

.bottom {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 100px;
  width: 450px;
  box-sizing: border-box;
  color: #333;
  display: flex;
  align-items: center;
  font-size: 32px;
  .left {
    border-top: 2px solid #e4e4e4;
    height: 100%;
    flex: 1;
    line-height: 98px;
    text-align: center;
  }
  .right {
    height: 100%;
    flex: 1;
    color: #fff;
    line-height: 98px;
    text-align: center;
    background: #e42129;
  }
}
.hidden {
  display: none;
}
</style>


<template>
  <div class="shop">
    <!-- <GoodsPopup ref="popup" @setCate_id='setCate_id' /> -->
    <Popup v-model="show" position="left" class="vant-popup">
      <div class="cate_box">
        <h5 class="all" @click="getALl">全部商品</h5>
        <ul class="cate_box_ul">
          <li
            v-for="item in cateList"
            :key="item.id"
            class="cate_item"
            :class="{ cate_open:item.open }"
            @click="open(item)"
          >
            <div class="title_box">
              <span>{{ item.title }}</span>
              <img :src="item.open ? imgList[1]:imgList[0]" :class="{hidden:type=== 2}" />
            </div>
            <div
              class="child_box"
              :class="{child_title:el.open}"
              v-for="el in  item._child"
              :key="el.id"
              @click.stop="selChild(item,el)"
            >{{ el.title }}</div>
          </li>
        </ul>
      </div>
      <div class="bottom">
        <div class="left" @click="show = false">取消</div>
        <div class="right" @click="reset">确定</div>
      </div>
    </Popup>

    <div class="hander">
      <div class="right" @click="cate">
        <img src="../assets/shop/sort.png" />
        <span>分类</span>
      </div>
      <div class="left">
        <img src="../assets/home/search.png" />
        <input type="text" placeholder="请输入关键词" v-model="title" @blur="blur" @keyup.enter="blur" />
      </div>
    </div>
    <div class="screen">
      <div class="t1" :class="line == 1 && 't3'" @click="lineCss(1)">综合</div>
      <div class="price" @click="lineCss(2)">
        <div class="t2" :class="line == 2 && 't3'">销量</div>
        <div class="image">
          <img class="top" :src="upimg && line == 2 ? upPriceImg[0]:upPriceImg[1] " />
          <img class="bot" :src="!upimg && line == 2 ?upPriceImg[0]:upPriceImg[1] " />
        </div>
      </div>
      <div class="price" @click="lineCss(3)">
        <div class="t2" :class="line == 3 && 't3'">新品</div>
        <div class="image">
          <img class="top" :src="upimg && line == 3 ? upPriceImg[0]:upPriceImg[1] " />
          <img class="bot" :src="!upimg && line == 3 ?upPriceImg[0]:upPriceImg[1] " />
        </div>
      </div>
      <div class="price" @click="lineCss(4)">
        <div class="t2" :class="line == 4 && 't3'">价格</div>
        <div class="image">
          <img class="top" :src="upimg && line == 4 ? upPriceImg[0]:upPriceImg[1] " />
          <img class="bot" :src="!upimg && line == 4 ?upPriceImg[0]:upPriceImg[1] " />
        </div>
      </div>
      <div class="line" :style="lineStyle"></div>
    </div>
    <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getGoodsList">
      <div class="goodsBox">
        <GoodsItem v-for="item in goods" :goods="item" :key="item.id" />
      </div>
    </van-list>
  </div>
</template>
<script>
import GoodsItem from "../component/GoodsItem";
import GoodsPopup from "../component/goods/goodsPopup";
import merge from 'webpack-merge'


import { Popup } from "vant";

export default {
  name: "home",
  components: {
    GoodsItem,
    GoodsPopup,
    Popup
  },
  data() {
    return {
      line: 1,
      upimg: true,
      upPriceImg: [
        require("../assets/shop/is_active.png"),
        require("../assets/shop/no_active.png")
      ],
      imgList: [
        require("../assets/shop/zhankai.png"),
        require("../assets/shop/shouqi.png")
      ],
      show: false,
      goods: [],
      cateList: [],
      cate_id: "",
      type: 1,
      cate_show: false,
      title: "",
      page: 1,
      loading: false,
      finished: false
    };
  },
  computed: {
    lineStyle() {
      return `left:${(this.line - 1) * 25}%`;
    },
    order() {
      let line = this.line;
      let upimg = this.upimg;
      if (line == 1) {
        return "0";
      } else if (line == 2) {
        if (!upimg) {
          return "1";
        } else {
          return "2";
        }
      } else if (line == 3) {
        if (!upimg) {
          return "3";
        } else {
          return "4";
        }
      } else if (line == 4) {
        if (!upimg) {
          return "5";
        } else {
          return "6";
        }
      }
    },
    ccate() {
      return this.$store.state.cate;
    }
  },
  watch: {
    $route(to, from) {
      let query = this.$route.query;
      this.type = query.type || 1;
      this.cate_id = query.id || "";

      if (query.x == 1) {
        this.line = 3;
      }

      
      this.finished = false;
      this.page = 1;
      this.getGoodsList();

      this.getCate();
      // setTimeout(() => {
      //   this.finished = true
      // }, 300);
    }
  },
  created() {
    let query = this.$route.query;

    this.type = query.type || 1;
    this.cate_id = query.id || "";

    if (query.x == 1) {
      this.line = 3;
    }
    // this.getGoodsList();
    this.page = 1;
    this.getCate();
  },
  methods: {
    // 获取商品
    getGoodsList() {
      this.show = false;
      let title = this.title;
      let order = this.order;
      let type = this.type;
      let cate_id = this.cate_id;
      let data = { order, type };
      data.page = this.page;
      if (title != "") data.title = title;
      if (cate_id != "") data.cate_id = cate_id;
      this.$router.push({
        query:merge(this.$route.query,{"id":this.cate_id})
      })
      this.$http({
        url: "goodsList",
        data
      })
        .then(res => {
          if (this.page == 1 && res == "无商品信息") this.goods = [];
          if (res == "无商品信息") {
            this.loading = false;
            this.finished = true;
            return;
          }

          if (!res._list) {
            this.loading = false;
            this.finished = true;
            return;
          }
          if (res.nowPage) {
            this.goods =
              res.nowPage == 1 ? res._list : this.goods.concat(res._list);
            this.page = ++res.nowPage;
            this.loading = false;
          } else {
            if (this.page == 1 && res == "无商品信息") this.goods = [];
          }
        })
        .catch(err => {
          this.loading = false;
          this.finished = true;
          // this.$toast.error(err.message)
          this.goods = [];
          this.$toast("获取数据失败");
        });
    },
    blur() {
      console.log(1);
      this.page = 1;
      this.getGoodsList();
    },
    setCate_id(e) {
      console.log(e, 9999);
      this.cate_id = e;
      this.page = 1;
      this.title = "";
      this.getGoodsList();
    },

    lineCss(num) {
      if (this.line != num) {
        this.upimg = false;
      } else {
        this.upimg = !this.upimg;
      }
      this.line = num;
      this.page = 1;
      this.getGoodsList();
    },
    getCate() {
      this.$http({
        url: "goodsCate",
        data: {
          type: this.type
        }
      }).then(res => {
        let cate_id = this.cate_id;
        this.cateList = res.map(item => {
          item.open = false;
          if (item.id === cate_id) item.open = true;

          if (item._child) {
            item._child = item._child.map(el => {
              el.open = false;
              return el;
            });
          } else {
            item._child = [];
          }
          return item;
        });

        // let cate = res;
        // cate.forEach(ele => {
        //   // flag 用于判断一级分类 是否展开
        //   ele.flag = true;
        //   if (ele.id == cate_id) ele.flag = false;

        //   if (ele._child) {
        //     ele._child.forEach(item => (item.flag = true));
        //   } else {
        //     ele._child = [];
        //   }
        // });
        // this.$store.commit("setCate", cate);
      });
    },
    cate() {
      this.show = true;
    },
    open(item) {
      let cateList = this.cateList;
      let cate_id = item.id;
      this.cate_id = cate_id;
      // if (item._child.length === 0) {
      //   item.open = true
      //   this.page = 1;
      //   this.getGoodsList();
      //   return;
      // }

      cateList = cateList.map(item => {
        item.open = false;
        if (item.id === cate_id) item.open = true;
        if (item._child) {
          item._child = item._child.map(el => {
            el.open = false;
            return el;
          });
        } else {
          item._child = [];
        }
        return item;
      });



    },
    selChild(item, el) {
      this.cate_id = el.id;
      item._child = item._child.map(i => {
        i.open = false;
        if (el.id === i.id) {
          i.open = true;
        }
        console.log(i);
        return i;
      });
      this.cateList = this.cateList.map(i => {
        if (i.id === item.id) i = item;
        return i;
      });

      
      
      
      this.page = 1;
      this.getGoodsList();
    },
    reset() {
      this.page = 1;
      this.getGoodsList();
    },
    getALl(){
      this.cate_id = ''
      this.page = 1
      this.finished = false
      this.getGoodsList()
    }
  }
};
</script>
